import Select, { SelectOption } from '@anm/components/select/Select';
import { FC } from 'react';

import { Controls } from '../ControlsPanel';
import { CurrentValue } from '../index';

import TooltipWrapper, { Wrapper } from './Wrapper';
import useCustomizationFormSelect from './hooks';

export type SelectProps = Controls & {
  onChange: (value: CurrentValue) => void;
  values: SelectOption[];
  renderTooltip?: () => JSX.Element;
};

const CustomizationFormSelect: FC<SelectProps> = props => {
  const { values, disabled, renderTooltip } = props;
  const [selectValue, handleSelectChange] = useCustomizationFormSelect(props);

  return (
    <Wrapper>
      <TooltipWrapper variant="white" renderContent={renderTooltip}>
        <Select
          name="select"
          size="small"
          value={selectValue}
          label={selectValue.label}
          options={values}
          disabled={disabled}
          onChange={handleSelectChange}
        />
      </TooltipWrapper>
    </Wrapper>
  );
};

export default CustomizationFormSelect;
